import { useSignInPage } from '@core/hooks/useSignInPage'
import { useSso } from '@core/hooks/useSso'
import {
  signInSearchSchema,
  ssoPropsFromSearch,
} from '@core/utils/sign-in-search'
import { ContentWithTop } from '@design/components/layouts/content-with-top/ContentWithTop'
import { SignInScreen } from '@design/components/screens/sign-in-screen/SignInScreen'
import { IntroHeader } from '@discover/components/layout/IntroHeader'
import { ROUTES } from '@discover/utils/router/paths'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/sign-in')({
  component: SignIn,
  validateSearch: (search) => signInSearchSchema.parse(search),
})

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN

function SignIn() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  const signInProps = useSignInPage({
    onSuccess: () => navigate({ to: ROUTES.root }),
    forgotPasswordUrl: ROUTES.forgotPassword,
  })
  const sso = useSso({ cognitoDomain })

  return (
    <ContentWithTop className='h-dvh' top={<IntroHeader />}>
      <SignInScreen
        sso={sso}
        {...signInProps}
        {...ssoPropsFromSearch(search)}
      />
    </ContentWithTop>
  )
}
